import { observer } from 'mobx-react';
import { BUTTON_VARIANTS } from '../../../../../../../../components/inputs/button-variants';
import FedexV2RegistrationModalLayout from '../fedex-v2-registration-modal-layout';
import FedexV2RegistrationMfaSelectStep from '../steps/fedex-v2-registration-mfa-select-step';
import { IFedexV2RegistrationModalStepProps } from './fedex-v2-registration-modal-step-props';

const FedexV2RegistrationMfaSelectModalStep: React.FC<IFedexV2RegistrationModalStepProps> = observer(({
    registration,
}) => {
    const loading = registration.isLoading;
    const mfaOptions = registration.mfaSelectOptions;
    const buttons = registration.mfa.hasSecureCodeDeliveryOptions
        ? [{
            text: 'Send PIN',
            variant: BUTTON_VARIANTS.Primary,
            onClick: registration.startPinVerification,
            hasLoader: true,
            isLoading: loading,
        }]
        : [];

    return (
        <FedexV2RegistrationModalLayout registration={registration} buttons={buttons}>
            <FedexV2RegistrationMfaSelectStep mfa={registration.mfa} mfaOptions={mfaOptions} />
        </FedexV2RegistrationModalLayout>
    );
});

export default FedexV2RegistrationMfaSelectModalStep;
